/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { ErrorProps } from "./interfaces";
import { ErrorStyle } from "./styles";
import { useIsMobile } from "../../hooks/useIsMobile";
import errorLogo from "../../assets/warning-red-logo.svg";

export const ErrorComponent: React.FunctionComponent<ErrorProps> = (props) => {
  const { errorObj } = props;
  const isMobileView = useIsMobile();

  return (
    <span css={ErrorStyle}>
      <div
        className={`d-flex align-items-center justify-content-center my-4 p-4 ${
          isMobileView
            ? "error-mobile-parent-container"
            : "error-parent-container"
        }`}
      >
        <div className="d-flex justify-content-center align-items-start">
          <img src={errorLogo} alt="" className="logo-responsive-styling" />
          <div className="ml-2 error-container">
            <h5 className="error-container">{errorObj?.title || "Error"}</h5>
            <div className="error-description">
              {errorObj?.message ||
                "Something went wrong. Please retry after sometime. If issue persists, please reach out to partner.support@curefit.com with details on issue you are facing with relevant screenshots if any."}
            </div>
          </div>
        </div>
      </div>
    </span>
  );
};
